import { useState, useEffect } from 'react';

const useActiveSection = () => {
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const sections = [
      { id: 'home', element: null },
      { id: 'product', element: null },
      { id: 'platform', element: null },
      { id: 'benefits', element: null },
      { id: 'services', element: null },
      { id: 'pricing', element: null },
      { id: 'faq', element: null },
      { id: 'about', element: null },
      { id: 'contact', element: null }
    ];

    // Get section elements
    sections.forEach(section => {
      section.element = document.querySelector(`#${section.id}`) ||
        document.querySelector(`[id="${section.id}"]`);
    });

    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100; // Offset for header

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section.element) {
          const sectionTop = section.element.offsetTop;
          if (scrollPosition >= sectionTop) {
            setActiveSection(section.id);
            break;
          }
        }
      }
    };

    // Set initial active section
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return activeSection;
};

export default useActiveSection;
